import { SOLD_SERVICE_STATUS } from '@sales-center/common'

export const soldServiceBackgroundColor = (
  status: SOLD_SERVICE_STATUS,
): string => {
  switch (status) {
    case SOLD_SERVICE_STATUS.Completed:
      return '#EDF7ED'
    case SOLD_SERVICE_STATUS.NotSent:
      return '#FEECEB'
    case SOLD_SERVICE_STATUS.Processing:
      return '#FDF0E6'
    case SOLD_SERVICE_STATUS.Revise:
      return '#FEECEB'
    case SOLD_SERVICE_STATUS.Submitted:
      return '#E9F4FE'
    default:
      return '#FEECEB'
  }
}
